import React, { useRef, useState } from 'react';
import './Scheduling.css';

import { EmptyFieldWarning } from 'pages/EHRPage/components/EmptyFieldWarning';
import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';
import { CarouselScheduling } from './components/CarouselScheduling';
import { WeekDaysChoise } from './components/WeekDaysChoise';
import { CardScheduleDetails } from './components/CardScheduleDetails';

export function Scheduling() {
  const { appointment } = useTeleconsultingContext();

  const calendarRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [searchField, setSearchField] = useState('');
  const [weekDaysKey, setWeekDaysKey] = useState(0);

  const seenDays = new Set();

  const filterDate = appointment?.entry
    ?.map((el) => {
      return new Date(el?.resource?.start?.replace(/\s/g, ''));
    })
    ?.filter((date) => {
      const day = date.toISOString().split('T')[0];
      if (seenDays.has(day)) {
        return false;
      }
      seenDays.add(day);
      return true;
    }) || [new Date()];

  const filterAppointment = appointment?.entry?.filter((element) => {
    const dateAppointment = new Date(
      element?.resource?.start?.replace(/\s/g, ''),
    );
    const title = element?.resource?.appointmentType?.text?.toLowerCase();
    const locale =
      element?.resource?.participant?.[2]?.actor?.display?.toLowerCase();
    const search = searchField?.toLowerCase();
    return (
      (searchField
        ? title?.includes(search) || locale?.includes(search)
        : element) && (selectedDate ? dateAppointment >= selectedDate : element)
    );
  });

  return (
    <div className="SchedulingContent">
      <h1 className="titleScheduling">Minha agenda</h1>
      {filterDate && (
        <CarouselScheduling
          calendarRef={calendarRef}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          weekDaysKey={weekDaysKey}
          setWeekDaysKey={setWeekDaysKey}
          filterDate={filterDate}
        />
      )}

      <WeekDaysChoise
        key={weekDaysKey}
        selectedDate={selectedDate}
        setSelectedDate={setSelectedDate}
        filterDate={filterDate}
      />

      <div className="searchSchedule">
        <input
          className="inputSearch"
          onChange={(e) => setSearchField(e.target.value)}
          type="text"
          placeholder="Buscar na agenda"
        />
      </div>

      {filterAppointment?.length > 0 ? (
        filterAppointment
          ?.sort((initValue, endValue) => {
            const initial = new Date(initValue?.resource?.start);
            const final = new Date(endValue?.resource?.start);
            return initial - final;
          })
          ?.map((el) => <CardScheduleDetails resource={el.resource} />)
      ) : (
        <div style={{ width: '72%' }}>
          <EmptyFieldWarning message="Você não possui agendamentos" />
        </div>
      )}
    </div>
  );
}
